/* eslint-disable no-restricted-syntax */
/* eslint-disable indent */
/* eslint-disable max-len */
import Glide from '@glidejs/glide';
import $ from 'jquery';
import { isLG } from '../../util/domutils';

const SELECTORS = {
  NAVIGATORS: {
    ARROWS: '.glide__arrows',
  },
  PRODUCTS: '.product',
};

  const CustomLength = function (glide, Components, Events) {
    const addToBagCarouselEvents = {
      handleSlider() {
        if (Components.Sizes.length <= glide.settings.perView) {
          glide.disable();
          Components.Html.root.querySelector(SELECTORS.NAVIGATORS.ARROWS).classList.add('d-none');
        } else {
          glide.enable();
          Components.Html.root.querySelector(SELECTORS.NAVIGATORS.ARROWS).classList.remove('d-none');
        }
        if (!isLG() && glide) {
          glide.destroy();
        }
      },
      mount() {
        this.handleSlider();
      },
    };
    Events.on('resize', () => {
      addToBagCarouselEvents.handleSlider();
    });
    return addToBagCarouselEvents;
  };

  const FixBoundPeek = function (GlideComponent, Components) {
    return {
      modify(translate) {
        let { isBound } = Components.Run.isBound;
        if (typeof isBound !== 'function') {
          isBound = function () {
            // eslint-disable-next-line max-len
            return GlideComponent.isType('slider') && GlideComponent.settings.focusAt !== 'center' && GlideComponent.settings.bound;
          };
        }

        if (isBound() && Components.Run.isEnd() && Components.Sizes.length > GlideComponent.settings.perView) {
          const peek = Components.Peek.value;
          if (typeof peek === 'object' && peek.after && (Components.Sizes.length > GlideComponent.settings.perView)) {
            return translate - peek.after;
          }
          if (typeof peek !== 'object') {
            return translate - peek;
          }
        }
        return translate;
      },
    };
  };

  const PDPWaystowear = function () {
    if ($('.waystowear-sub-products .recommendation-carousel-pdp').length) {
      const sliders = document.querySelectorAll('.waystowear-sub-products .recommendation-carousel-pdp');
      let glideBreakpoints = {
        4000: {
          perView: 5,
          peek: { before: 0, after: 0 },
        },
        991: {
          perView: 3,
          peek: { before: 0, after: 90 },
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 120 },
        },
      };
      for (let i = 0; i < sliders.length; i++) {
        const hasProducts = !!sliders[i].querySelector(SELECTORS.PRODUCTS);
        if (hasProducts) {
          if (sliders[i].closest('.product-detail__product-carousel')) {
            sliders[i].closest('.product-detail__product-carousel').classList.remove('d-none');
          }

          const tileRow = sliders[i].closest('.waystowear-sub-products');

          if (tileRow && tileRow.getAttribute('data-breakpoints')) {
            const breakpointsData = tileRow.getAttribute('data-breakpoints');

            try {
              const parsedBreakpoints = JSON.parse(breakpointsData);
              if (typeof parsedBreakpoints === 'object' && parsedBreakpoints !== null) {
                glideBreakpoints = parsedBreakpoints;
              }
            } catch (e) {
              throw e;
            }
          }

          const settings = {
            type: 'slider',
            rewind: false,
            gap: 8,
            bound: true,
            breakpoints: glideBreakpoints,
          };

          const glide = new Glide(sliders[i], settings);
          if (isLG()) {
            glide.mutate([FixBoundPeek]).mount({ CustomLength });
          }
        }
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  const PDPCarouselInit = function () {
    if ($('.recommendation-carousel-pdp').length) {
      const sliders = document.querySelectorAll('.recommendation-carousel-pdp');
      let glideBreakpoints = {
        4000: {
          perView: 5,
          peek: { before: 0, after: 0 },
        },
        991: {
          perView: 3,
          peek: { before: 0, after: 90 },
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 120 },
        },
      };
      for (let i = 0; i < sliders.length; i++) {
        const hasProducts = !!sliders[i].querySelector(SELECTORS.PRODUCTS);
        if (hasProducts) {
          if (sliders[i].closest('.product-detail__product-carousel')) {
            sliders[i].closest('.product-detail__product-carousel').classList.remove('d-none');
          }

          const tileRow = document.querySelector('.style_with_product_recs_container ');

          if (tileRow && tileRow.getAttribute('data-breakpoints')) {
            const breakpointsData = tileRow.getAttribute('data-breakpoints');

            try {
              const parsedBreakpoints = JSON.parse(breakpointsData);
              if (typeof parsedBreakpoints === 'object' && parsedBreakpoints !== null) {
                glideBreakpoints = parsedBreakpoints;
              }
            } catch (e) {
              throw e;
            }
          }

          const settings = {
            type: 'slider',
            rewind: false,
            gap: 8,
            bound: true,
            breakpoints: glideBreakpoints,
          };

          const glide = new Glide(sliders[i], settings);
          if (isLG()) {
            glide.mutate([FixBoundPeek]).mount({ CustomLength });
          }
        }
      }
    }
  };

  const PDPCarouselYouMightLike = function () {
    const slider = document.querySelector('.product-detail_you-might-also-like .pdp-glide-container');

    if (slider) {
      let glideBreakpoints = {
        4000: {
          perView: 5,
          peek: { before: 0, after: 0 },
        },
        991: {
          perView: 3,
          peek: { before: 0, after: 90 },
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 120 },
        },
      };

      const tileRow = document.querySelector('.product-detail_you-might-also-like');

      if (tileRow && tileRow.getAttribute('data-breakpoints')) {
        const breakpointsData = tileRow.getAttribute('data-breakpoints');

        try {
          const parsedBreakpoints = JSON.parse(breakpointsData);
          if (typeof parsedBreakpoints === 'object' && parsedBreakpoints !== null) {
            glideBreakpoints = parsedBreakpoints;
          }
        } catch (e) {
          throw e;
        }
      }

      try {
        const hasProducts = !!slider.querySelector('.product');
        if (hasProducts) {
          if (slider.closest('.product-detail__product-carousel')) {
            slider.closest('.product-detail__product-carousel').classList.remove('d-none');
          }
        }
        const glide = new Glide(slider, {
          type: 'slider',
          bound: true,
          rewind: false,
          gap: 8,
          breakpoints: glideBreakpoints,
        });

        if (isLG()) {
          glide.mutate([FixBoundPeek]).mount({ CustomLength });
        }
      } catch (e) {
        throw e;
      }
    }
  };

  const PDPEinsteinRecsCarouselInit = function () {
    const slider = document.querySelector('.product-detail__recently-viewed .pdp-glide-container');

    if (slider) {
      let glideBreakpoints = {
        4000: {
          perView: 5,
          peek: { before: 0, after: 0 },
        },
        991: {
          perView: 3,
          peek: { before: 0, after: 90 },
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 120 },
        },
      };

      const tileRow = document.querySelector('.product-detail__recently-viewed');

      if (tileRow && tileRow.getAttribute('data-breakpoints')) {
        const breakpointsData = tileRow.getAttribute('data-breakpoints');

        try {
          const parsedBreakpoints = JSON.parse(breakpointsData);
          if (typeof parsedBreakpoints === 'object' && parsedBreakpoints !== null) {
            glideBreakpoints = parsedBreakpoints;
          }
        } catch (e) {
          throw e;
        }
      }

      try {
        const hasProducts = !!slider.querySelector('.product');
        if (hasProducts) {
          if (slider.closest('.product-detail__product-carousel')) {
            slider.closest('.product-detail__product-carousel').classList.remove('d-none');
          }
        }

        const glide = new Glide(slider, {
          type: 'slider',
          bound: true,
          rewind: false,
          gap: 8,
          breakpoints: glideBreakpoints,
        });

        if (isLG()) {
          glide.mutate([FixBoundPeek]).mount({ CustomLength });
        }
      } catch (e) {
        throw e;
      }
    }
  };

  export default () => {
    $(document).ready(() => {
      PDPCarouselInit();
      PDPCarouselYouMightLike();
      PDPEinsteinRecsCarouselInit();
      PDPWaystowear();
    });
    window.onload = () => {
      PDPCarouselInit();
      PDPWaystowear();
    };
    // $(document).on('change', '.product-detail__tile-row-container', () => { PDPCarouselInit(); });
    document.addEventListener('product:afterloadEinstienSlot', () => { PDPCarouselInit(); });
    document.addEventListener('product:afterAttributeSelect', () => {
      PDPCarouselInit();
      PDPWaystowear();
    });
    document.addEventListener('product:carousel-init', () => {
      PDPEinsteinRecsCarouselInit();
      PDPCarouselYouMightLike();
  });
  const mediaQuery = window.matchMedia('(min-width: 992px)');

  function handleGlideCarousel(event) {
    if (event.matches) {
      PDPCarouselYouMightLike();
      PDPEinsteinRecsCarouselInit();
    }
  }
  // Initial check
  handleGlideCarousel(mediaQuery);

  // Listen for changes in media query status
  mediaQuery.addEventListener('change', handleGlideCarousel);
};
